export default {
  getUserInfo(state) {
    return state.userInfo || null;
  },

  getDealer(state) {
    return state.userInfo?.dealer ?? null;
  },

  getDealerCurrencyRate(_, getters) {
    const dealer = getters?.getDealer;
    const rate = dealer?.is_currency_fix_rate
      ? dealer?.currency_fix_rate_value
      : dealer?.rate_with_markup;

    return rate || 0;
  },

  getSupplierCurrencyRate(_, getters) {
    const dealer = getters?.getDealer;
    const rate = dealer?.parent_dealer?.is_currency_fix_rate
      ? dealer?.parent_dealer?.currency_fix_rate_value
      : dealer?.parent_dealer?.rate_with_markup;

    return rate || 0;
  },

  getDealerWarehousesList(state) {
    const obj = state.userInfo?.warehouses_list || {};
    const list = [];

    for (const key in obj) {
      const item = obj[key];
      for (const itemKey in item) {
        list.push({ name: item[itemKey], alias: itemKey, code: key });
      }
    }

    return list;
  },

  getDealerName(state, getters) {
    return getters.getDealer?.name ?? '';
  },

  getDealerAvatar(state, getters) {
    return getters.getDealer?.image ?? '';
  },

  getDealerEmployee(state, getters) {
    return getters.getDealer?.parent_dealer_employee ?? null;
  },

  getDealerPricelist(state, getters) {
    return getters.getDealer?.is_own_pricelist_allowed ?? null;
  },

  getDealerContractors(state) {
    return state.userInfo?.contractors || [];
  },

  hasDealerContractors(_, getters) {
    const list = getters.getDealerContractors || [];

    return list?.length > 1;
  },

  hasDealerProduction(state, getters) {
    return getters.getDealer?.has_production ?? 0;
  },
};
